import { render, staticRenderFns } from "./create-carousel.vue?vue&type=template&id=2cae3bf0&scoped=true"
import script from "./create-carousel.vue?vue&type=script&lang=ts"
export * from "./create-carousel.vue?vue&type=script&lang=ts"
import style0 from "./create-carousel.vue?vue&type=style&index=0&id=2cae3bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cae3bf0",
  null
  
)

export default component.exports